/**
 * Enumeration of page names (app page in CMS converted to lower case)
 */
export enum ApplicationPages {
	InputPage = "input page",
	OverviewPage = "overview page",
	ConfirmationPage = "confirmation page"
}